import React from 'react';
interface PlateCodeProps {
  className?: string;
}
const steps = [{
  n: '1',
  label: 'Verdes',
  detail: 'Fibra primero'
}, {
  n: '2',
  label: 'Proteína y grasa',
  detail: 'El escudo'
}, {
  n: '3',
  label: 'Carbohidratos',
  detail: 'Al final'
}];

/** Infografía central del método: el plato dividido en el orden 1-2-3. */
export function PlateCode({
  className = ''
}: PlateCodeProps) {
  return <div className={className} data-id="element-502" data-mp="38pqxqjqodof3">
      <svg viewBox="0 0 320 320" className="mx-auto h-auto w-full max-w-[320px]" role="img" aria-label="Plato dividido en tres partes numeradas: 1 verdes y fibra, 2 proteína y grasa, 3 carbohidratos" data-id="element-503" data-mp="38r20cg8dwq4m">
        <circle cx="160" cy="160" r="150" fill="#ffffff" stroke="#e6e9e0" strokeWidth="2" data-id="element-504" data-mp="2yzxmxkycxdbw" />
        <circle cx="160" cy="160" r="132" fill="none" stroke="#d4af37" strokeWidth="1.5" data-id="element-505" data-mp="2uznhqaie2qy3" />

        {/* 1 — Verdes (mitad izquierda) */}
        <path d="M160 32 A128 128 0 0 0 160 288 Z" fill="#1a472a" data-id="element-506" data-mp="2kzwmu7px29xh" />
        {/* 2 — Proteína y grasa (cuarto superior derecho) */}
        <path d="M160 32 A128 128 0 0 1 288 160 L160 160 Z" fill="#4caf50" data-id="element-507" data-mp="206z7llc8q6p8" />
        {/* 3 — Carbohidratos (cuarto inferior derecho) */}
        <path d="M288 160 A128 128 0 0 1 160 288 L160 160 Z" fill="#d4af37" data-id="element-508" data-mp="24z8ustlz0snt" />

        <g fill="#ffffff" fontFamily="Inter, sans-serif" fontWeight="800" textAnchor="middle" data-id="element-509" data-mp="1r7uamjgbulf6">
          <text x="100" y="170" fontSize="44" data-id="element-510" data-mp="1w6p0u6gmjc9b">
            1
          </text>
          <text x="214" y="116" fontSize="32" data-id="element-511" data-mp="2juovvikyxotp">
            2
          </text>
          <text x="214" y="228" fontSize="32" data-id="element-512" data-mp="2nwti3w937j6b">
            3
          </text>
        </g>

        <circle cx="160" cy="160" r="34" fill="#ffffff" data-id="element-513" data-mp="2nuh4twe9xwzl" />
        <text x="160" y="156" textAnchor="middle" fill="#1a472a" fontFamily="Inter, sans-serif" fontSize="13" fontWeight="800" data-id="element-514" data-mp="29w91n6qn9zfz">
          ORDEN
        </text>
        <text x="160" y="172" textAnchor="middle" fill="#d4af37" fontFamily="Inter, sans-serif" fontSize="13" fontWeight="800" data-id="element-515" data-mp="yi57o0k24bax">
          1-2-3
        </text>
      </svg>

      <ol className="mt-6 grid gap-3 sm:grid-cols-3" data-id="element-516" data-mp="13evqgvn8xl01">
        {steps.map((step, index) => <li key={step.n} className="flex items-start gap-3" data-id="element-517" data-mp="je2fr12hjjzw" data-mpi={index}>
            <span className={['flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-extrabold text-white', index === 0 ? 'bg-forest' : index === 1 ? 'bg-leaf' : 'bg-gold'].join(' ')} aria-hidden="true" data-id="element-518" data-mp="fd0fcgwu11wc">
              {step.n}
            </span>
            <span data-id="element-519" data-mp="oco2mu0rec7">
              <span className="block text-sm font-bold text-forest" data-id="element-520" data-mp="ovvvapygmci">{step.label}</span>
              <span className="block text-xs text-muted" data-id="element-521" data-mp="3rux7bkdu1hyo">{step.detail}</span>
            </span>
          </li>)}
      </ol>
    </div>;
}